import { createFileRoute, redirect } from '@tanstack/react-router';
import { queryClient } from '@/api/common/client';
import { ensureAuthData } from '@/api/auth/auth-query';
import { GlobalRole } from '@/lib/auth/models';
import { isAdminOrSystemRole } from '@/lib/auth/roles';
import {
  ADMIN_PRODUCT_RELEASES,
  REFERRER_PRODUCT_RELEASES,
  SIGN_IN,
} from '@/lib/constants/routes';

export const Route = createFileRoute('/releases')({
  beforeLoad: async () => {
    const data = await ensureAuthData(queryClient);
    if (!data.authenticated || !data.user) {
      throw redirect({ to: SIGN_IN });
    }

    if (data.user.globalRole === GlobalRole.REFERRER) {
      throw redirect({ to: REFERRER_PRODUCT_RELEASES });
    }

    if (isAdminOrSystemRole(data.user.globalRole)) {
      throw redirect({ to: ADMIN_PRODUCT_RELEASES });
    }

    throw redirect({ to: SIGN_IN });
  },
});
